import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import {
    BarcodeFormatter,
    ComponentFormatter,
    ProductColumn,
    ProductSelect,
    productTooltip,
    UnitFormatter
} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {ifCompletedInput} from "../../../utils/other";
import Select from "../../form/Select";
import StoreOrderEditor from "../storeorder/storeorderEditor";
import FragmentEditor from "../FragmentEditor";
import ModalEditor from "../ModalEditor";
import Button from "../../form/Button";
import CheckBox from "../../form/CheckBox";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import {Tooltip} from "react-tippy";
import Icon from "../../form/Icon";
import ComponentConfig from "../../form/ComponentConfig";
import classNames from "classnames";
import DetailsButton from "../../form/DetailsButton";

const sortable = true;
const filterable = true;

const accepted = rowData => parseInt(rowData.correction || 0) + parseInt(rowData.physical || 0) + parseInt(rowData.technical || 0) === parseInt(rowData.qty || 0);

class StoreOrderClaimExists extends React.Component {
    render() {
        const componentButton = !this.props.client;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-2 col-sm-pull-4">
                        <TextInput
                            name="client_component_type"
                            value={this.props.values.client_component_type}
                            label="Tevékenység"
                            saveChanges={this.props.setFieldValue}
                            formatter={(value) => ComponentFormatter({component: value})}
                            {...this.props.getFieldProps("client_component_type")}
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <div className="row">
                            <div className={classNames({"col-md-5": componentButton, "col-md-12": !componentButton})}>
                                <TextInput
                                    name="client_component_id"
                                    value={this.props.values.client_component_id}
                                    label="Id"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("client_component_id")}
                                    disabled={true}
                                />
                            </div>
                            {componentButton && <div className="col-md-7">
                                <DetailsButton
                                    component_type={this.props.values.client_component}
                                    component_id={this.props.values.client_component_id}
                                />
                            </div>}
                        </div>
                    </div>
                    <div className="col-sm-2 col-sm-pull-4">
                        <Select
                            storeType="local"
                            options={[
                                {key: "-1", label: "Hiány"},
                                {key: "1", label: "Többlet"}
                            ]}
                            label="Típus"
                            disabled={true}
                            objectValue={false}
                            value={this.props.values.type}
                            valueKey="key"
                            labelKey="label"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Tételek</label>
                        <SelectorGrid
                            className={"p-small-table"}
                            onLoadCompleted={(response) => {
                                if (this.props.setProcessSelected) {
                                    let sendClaim = false;
                                    if (response.aggregations && response.aggregations.length) {
                                        sendClaim = accepted(response.aggregations[0]);
                                    }
                                    this.props.setProcessSelected(sendClaim);
                                }
                            }}
                            view={["settled","product_id"]}
                            onItemUpdate={true}
                            aggregations={{
                                fields: {
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    },
                                    "physical": {
                                        field: "physical", type: "SUM"
                                    },
                                    "technical": {
                                        field: "technical", type: "SUM"
                                    },
                                    "correction": {
                                        field: "correction", type: "SUM"
                                    },
                                    "settled": {
                                        field: "settled", type: "SUM"
                                    },
                                }
                            }}
                            rowClassName={(rowData) => {
                                return {"danger color": !accepted(rowData)}
                            }}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("product_id"),
                                    width: 4,
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 1,
                                    sortable,
                                    filterable
                                },
                                "qty": {
                                    header: 'Összesen',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value, row.unit)
                                },
                                "physical": {
                                    header: 'Fizikai',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value, row.unit),
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            this.props.stateTypes.INITIATED_STATE(this.props.values.state) ? (props, value) =>
                                                <TextInput
                                                    type="number"
                                                    name="physical"
                                                    label={false}
                                                    focus
                                                    value={value}
                                                    onKeyDown={(e, field, value) => {
                                                        if (ifCompletedInput(e)) {
                                                            if (parseInt(value || 0) <= parseInt(props.rowData.qty || 0) - parseInt(props.rowData.technical || 0) - parseInt(props.rowData.correction || 0)) {
                                                                if (parseInt(value || 0) === 0) {
                                                                    value = null;
                                                                }
                                                                parent.onEditorValueChange(props, value);
                                                            }
                                                        }
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                /> : false
                                },
                                "technical": {
                                    header: 'Technikai',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value, row.unit),
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            this.props.stateTypes.INITIATED_STATE(this.props.values.state) ? (props, value) =>
                                                <TextInput
                                                    type="number"
                                                    name="technical"
                                                    label={false}
                                                    focus
                                                    value={value}
                                                    onKeyDown={(e, field, value) => {
                                                        if (ifCompletedInput(e)) {
                                                            if (parseInt(value || 0) <= parseInt(props.rowData.qty || 0) - parseInt(props.rowData.physical || 0) - parseInt(props.rowData.correction || 0)) {
                                                                if (parseInt(value || 0) === 0) {
                                                                    value = null;
                                                                }
                                                                parent.onEditorValueChange(props, value);
                                                            }
                                                        }
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                /> : false
                                },
                                ...(this.props.typeTypes.SHORTAGE(this.props.values.type) ? {"missing": {
                                        header: 'Hiány',
                                        width: 1,
                                        sortable,
                                        className: "flagbox",
                                        renderer: (value, row, rowIndex, props, parent) =>
                                            <CheckBox
                                                name="missing"
                                                value={value}
                                                disabled={!this.props.stateTypes.INITIATED_STATE(this.props.values.state)}
                                                label={false}
                                                saveChanges={(field, value) => {
                                                    parent.onEditorValueChange(props, value);
                                                }}
                                            />

                                    }}: {}),
                                "correction": {
                                    header: 'Korrekció',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value, row.unit),
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            this.props.stateTypes.INITIATED_STATE(this.props.values.state) ? (props, value) =>
                                                <TextInput
                                                    type="number"
                                                    name="correction"
                                                    label={false}
                                                    focus
                                                    value={value}
                                                    onKeyDown={(e, field, value) => {
                                                        if (ifCompletedInput(e)) {
                                                            if (parseInt(value || 0) <= parseInt(props.rowData.qty || 0) - parseInt(props.rowData.physical || 0) - parseInt(props.rowData.technical || 0) - parseInt(props.rowData.correction || 0)) {
                                                                if (parseInt(value || 0) === 0) {
                                                                    value = null;
                                                                }
                                                                parent.onEditorValueChange(props, value);
                                                            }
                                                        }
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                /> : false
                                }
                            }}
                            name={"items"}
                            itemActions={false}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("items")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Korrekciós rendelések</label>
                        <StoreOrderEditor
                            editorContext="StoreOrderClaimStoreOrderEditor"
                            client={this.props}
                            listFilter={[
                                {
                                    field: "client_component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            list={FragmentEditor}
                            editor={ModalEditor}
                            other={() => null}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                    </div>
                </div>
                {this.props.values.document && <SelectorDocuments value={[this.props.values.document]} />}
                {/*isTrue(this.props.values.involve) && <UrlField {...this.props}/>*/}
            </form>
        );
    }
}

class StoreOrderClaimNew extends React.Component {

    state = {
        product_ids: []
    }

    render() {
        const items = JSON.parse(JSON.stringify(this.props.values.items || {}));
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Tételek</label>
                        <SelectorGrid
                            className={"p-small-table"}
                            ref={(items) => this.items = items}
                            view={["product_id"]}
                            onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                                if (items.plusItem && field === "shortage") return false;
                                const newItems = JSON.parse(JSON.stringify(items));
                                if (!newItems[item.product_id]) {
                                    newItems[item.product_id] = JSON.parse(JSON.stringify(item));
                                }
                                if (["shortage", "surplus"].indexOf(field) !== -1) {
                                    const value = parseInt(item[field] || 0);
                                    newItems[item.product_id][field] = value || null;
                                } else {
                                    newItems[item.product_id][field] = item[field];
                                }
                                if (parseInt(newItems[item.product_id].shortage || 0) === 0 && parseInt(newItems[item.product_id].surplus || 0) === 0) {
                                    delete newItems[item.product_id];
                                }
                                this.props.setFieldValue("items", newItems);
                                return false;
                            }}
                            aggregations={{
                                fields: {
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    },
                                    "product_id": {
                                        field: "product_id", type: "GROUP_CONCAT"
                                    }
                                }
                            }}
                            onLoadCompleted={(response) => {
                                response = {...response};
                                this.setState({product_ids: (((response.aggregations || [])[0] || {}).product_id || "").split(",")});
                                response.rows = [...response.rows];
                                Object.values(items).map((product) => {
                                    if (this.state.product_ids.indexOf(product.product_id) === -1) {
                                        response.rows.push({...product, plusItem: true});
                                    }
                                });
                                return response;
                            }}
                            columns={{
                                "displayname": {
                                    header: 'Név',
                                    width: 4,
                                    sortable,
                                    filterable,
                                    tooltip: productTooltip("product_id"),
                                    renderer: (value, row) => {
                                        if (row.plusItem) {
                                            return <Fragment>
                                                <Button
                                                    icon={{lib: "fa", name: "times"}}
                                                    size={"xs"}
                                                    color="danger"
                                                    onClick={(e) => {
                                                        e && e.preventDefault();
                                                        const newItems = {...items};
                                                        delete newItems[row.product_id];
                                                        this.props.setFieldValue("items", newItems);
                                                        this.items && this.items.refresh();
                                                    }}
                                                />
                                                <span style={{fontStyle: "italic"}}> {value}</span>
                                            </Fragment>;
                                        }
                                        return value;
                                    }
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 1,
                                    sortable,
                                    filterable
                                },
                                "qty": {
                                    header: 'Összesen',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value || 0, row.unit)
                                },
                                "shortage": {
                                    header: 'Hiány',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    aggregation: (value, row) => UnitFormatter(Object.values(items).reduce((a, b) => Math.abs(a) + Math.abs(b.shortage), 0) || 0, row.unit),
                                    renderer: (value, row) => row.plusItem ? <div className="text-center">-</div> : UnitFormatter((items[row.product_id] || {}).shortage, row.unit),
                                    className: "unit",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                !props.rowData.plusItem && <TextInput
                                                    type="number"
                                                    name="shortage"
                                                    label={false}
                                                    focus
                                                    value={(items[props.rowData.product_id] || {}).shortage}
                                                    onKeyDown={(e, field, value) => {
                                                        ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}
                                                />
                                },
                                "surplus": {
                                    header: 'Többlet',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    aggregation: (value, row) => UnitFormatter(Object.values(items).reduce((a, b) => Math.abs(a) + Math.abs(b.surplus), 0) || 0, row.unit),
                                    renderer: (value, row) => UnitFormatter((items[row.product_id] || {}).surplus, row.unit),
                                    className: "unit",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput
                                                    type="number"
                                                    name="surplus"
                                                    label={false}
                                                    focus
                                                    value={(items[props.rowData.product_id] || {}).surplus}
                                                    onKeyDown={(e, field, value) => {
                                                        ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});
                                                    }}
                                                    onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}
                                                />
                                },
                                "missing": {
                                    header: 'Hiány',
                                    width: 1,
                                    sortable,
                                    className: "flagbox",
                                    renderer: (value, row, rowIndex, props, parent) =>
                                        items[props.rowData.product_id] ? props.rowData.plusItem ? "-" : <CheckBox
                                            name="missing"
                                            value={(items[props.rowData.product_id] || {}).missing}
                                            label={false}
                                            saveChanges={(field, value) => {
                                                parent.onEditorValueChange(props, value, {ignoreEqual: true});
                                            }}
                                        /> : false
                                }
                            }}
                            onSort={(field, direction) => {
                                if (field === "shortage" && !!Object.keys(items).length) {
                                    return {
                                        expression: "FIELD({{product_id}}, " + Object.keys(items).sort((a, b) => this.state.items[a].shortage - this.state.items[b].shortage).join(", ") + ")",
                                        direction
                                    };
                                }
                                if (field === "surplus" && !!Object.keys(items).length) {
                                    return {
                                        expression: "FIELD({{product_id}}, " + Object.keys(items).sort((a, b) => this.state.items[a].surplus - this.state.items[b].surplus).join(", ") + ")",
                                        direction
                                    };
                                }
                            }}
                            name={"items"}
                            itemActions={false}
                            data={this.props.client.values}
                            componentConfig={this.props.client.componentConfig}
                            {...this.props.getFieldProps("items")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            {...this.props.getFieldProps("productPicker")}
                            ref={(input) => this.productPicker = input}
                            label={"Új termék hozzáadása"}
                            component={"product"}
                            labelKey={"displayname"}
                            view={["displayname","barcode"]}
                            storeType={"remote"}
                            filter={[{field: "id", value: this.state.product_ids, operator: "not in"}]}
                            optionsTemplate={ProductSelect}
                            searchFormatter={BarcodeFormatter}
                            placeholder={"Vonalkód vagy cím"}
                            objectValue={true}
                            openIfHasOptions={true}
                            saveChanges={(field, product) => {
                                const newItems = {...items};
                                if (!newItems[product.id]) {
                                    newItems[product.id] = {...product, product_id: product.id, surplus: null, shortage: null};
                                }
                                this.props.setFieldValue("items", newItems);
                                this.items && this.items.refresh();
                            }}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

class StoreOrderClaimForm extends React.Component {

    render() {
        if (this.props.values[this.props.componentConfig.idfield]) {
            return <StoreOrderClaimExists {...this.props} />;
        } else if (this.props.client) {
            return <StoreOrderClaimNew {...this.props} />;
        } else {
            return null;
        }
    }
}

export default createForm(StoreOrderClaimForm);
